// extracted by css-extract-rspack-plugin
export default {"empty":"empty-ZHS8qO","emptyDescription":"emptyDescription-zrKWLL"};